export const RESET_GROUP_SHARE_START = 'RESET_GROUP_SHARE_START';
export const RESET_GROUP_SHARE_SUCCESS = 'RESET_GROUP_SHARE_SUCCESS';
export const RESET_GROUP_SHARE_FAILED = 'RESET_GROUP_SHARE_FAILED';
